import { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import PrinxContext from "contexts/prinxDataContext";
import { usePrivy } from "@privy-io/react-auth";
import BlockChainContext from "contexts/blockchainContext";
import { useLocation } from "react-router-dom";

export function GlobalModals() {
  const {
    showWhitelistRejectModal,
    setShowWhitelistRejectModal,
    showExitModal,
    setShowExitModal,
    setPrinxUser,
    setShowAttestationForm
  } = useContext(PrinxContext);
  const { logout } = usePrivy();
  const { setCompanyBalances, setSmartWalletAddress, setUsdcBalance } = useContext(BlockChainContext);
  const navigate = useNavigate();
  const [onramperMessage, setOnramperMessage] = useState<string | null>(null);

  function exitFlow() {
    navigate("/");
    logout();
    setPrinxUser(null);
    setSmartWalletAddress("");
    setUsdcBalance("0");
    setCompanyBalances({});
    setShowExitModal(false);
    setShowWhitelistRejectModal(false);
  }

  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("onramper");
    if (status === "success") {
      setOnramperMessage("Deposit successful! Funds should appear shortly.");
    } else if (status === "failure") {
      setOnramperMessage("Deposit failed. Please try again or contact support.");
    } else {
      setOnramperMessage(null);
    }

    // Also clean up old modals after nav
    setTimeout(() => {
      setShowWhitelistRejectModal(false);
      setShowAttestationForm(false);
    }, 50);
  }, [location.pathname, location.search]);

  return (
    <>
      {showExitModal &&
        createPortal(
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[2147483647]">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
              <h2 className="text-xl font-bold mb-4">Authentication Required</h2>
              <p className="text-gray-600 mb-4">
                You have attempted to exit our authentication flow. To access our platform, visitors must register an
                account. You may exit back to home screen or proceed with the authentication flow.
              </p>
              <div className="mt-auto flex justify-between py-4">
                <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={exitFlow}>
                  Exit
                </button>
                <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={() => setShowExitModal(false)}>
                  Proceed
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
      {showWhitelistRejectModal &&
        createPortal(
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[2147483647]">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
              <h2 className="text-xl font-bold mb-4">Allowlist Rejected</h2>
              <p className="text-gray-600 mb-4">
                To access our platform, visitors must have beta access. Contact support@prinx.io if you believe you
                should have beta access.
              </p>
              <div className="mt-auto flex justify-between py-4">
                <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={exitFlow}>
                  Exit
                </button>
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                  onClick={() => {
                    setShowWhitelistRejectModal(false);
                    navigate("/waitlist");
                  }}
                >
                  Join The Waitlist
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
      {onramperMessage &&
        createPortal(
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[2147483647]">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
              <h2
                className={`text-xl font-bold mb-4 ${
                  onramperMessage.includes("successful") ? "text-green-500" : "text-red-500"
                }`}
              >
                Deposit Status
              </h2>
              <p className="text-gray-600 mb-4">{onramperMessage}</p>
              <div className="mt-6 flex justify-center">
                <button
                  className={`px-4 py-2 rounded text-white ${
                    onramperMessage.includes("successful") ? "bg-green-500" : "bg-red-500"
                  }`}
                  onClick={() => {
                    setOnramperMessage(null);
                    navigate("/profile", { replace: true });
                  }}
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
